import React from 'react'
// import Header from './component/Header'
import Footer from '../component/Footer'
import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import api from '../api';
import DOMPurify from "dompurify"; // ✅ ADDED

const About = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [aboutUs, setAboutUs] = useState("");

    useEffect(() => {
        getAboutUs();

        window.scrollTo({ top: 0, behavior: 'auto' });

        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const getAboutUs = async () => {
        try {
            const res = await api.get("/admin/cms/about-us");
            console.log("About US Data >>>", res.data?.content)
            setAboutUs(res.data?.content);
        } catch (err) {
            console.log("Failed to About us", err);
        }
    }

    // ❌ KEEP your old function (not used now, but not removed)
    const stripHtml = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        const decoded = txt.value;
        return decoded.replace(/<[^>]*>/g, '');
    };

    // ✅ NEW: Decode HTML
    const decodeHtml = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    // ✅ NEW: Safe HTML render
    const getSafeHtml = () => {
        const decoded = decodeHtml(aboutUs || "");
        return DOMPurify.sanitize(decoded);
    };

    const testimonials = [
        {
            img: "assets/img/other/testimonial-thumb1.png",
            name: "Nike Mardson",
            subtitle: "fashion",
            desc: "Find everything you need — anytime, anywhere. Overay makes online shopping simple, safe, and affordable.",
        },
        {
            img: "assets/img/other/testimonial-thumb2.png",
            name: "Laura Johnson",
            subtitle: "fashion",
            desc: "Join millions of happy shoppers who trust Overay for quality, speed, and unbeatable deals every day.",
        },
        {
            img: "assets/img/other/testimonial-thumb3.png",
            name: "Richard Smith",
            subtitle: "fashion",
            desc: "Join millions of happy shoppers who trust Overay for quality, speed, and unbeatable deals every day.",
        },
        {
            img: "assets/img/other/testimonial-thumb1.png",
            name: "Nike Mardson",
            subtitle: "fashion",
            desc: "Shop smarter with Overay. From fashion to electronics, find everything you love delivered right to your door.",
        },
        {
            img: "assets/img/other/testimonial-thumb2.png",
            name: "Laura Johnson",
            subtitle: "fashion",
            desc: "Join millions of happy shoppers who trust Overay for quality, speed, and unbeatable deals every day.",
        },
        {
            img: "assets/img/other/testimonial-thumb3.png",
            name: "Richard Smith",
            subtitle: "fashion",
            desc: "At Overay, we bring you the best of fashion, lifestyle, and electronics — all with a click. Shop easy. Shop happy.",
        },
    ];

    return (
        <>
            <main className="main__content_wrapper">
                {/* About section */}
                <section className="about__section section--padding mb-95">
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-12">
                                <div className="about__content">
                                    {/* <span className="about__content--subtitle text__secondary mb-20">
                                        About Us
                                    </span> */}

                                    {/* ✅ ONLY THIS LINE CHANGED */}
                                    <div
                                        dangerouslySetInnerHTML={{ __html: getSafeHtml() }}
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <div className="counterup__banner--section counterup__banner__bg2" id="funfactId">
                    <div className="container">
                        <div className="row row-cols-1 align-items-center">
                            <div className="col">
                                <div className="counterup__banner--inner position__relative d-flex align-items-center justify-content-between">
                                    <div className="counterup__banner--items text-center">
                                        <h2 className="counterup__banner--items__text text-white">YEARS OF <br />
                                            FOUNDATION</h2>
                                        <span className="counterup__banner--items__number js-counter text-white" data-count="50">0</span>
                                    </div>
                                    <div className="counterup__banner--items text-center">
                                        <h2 className="counterup__banner--items__text text-white">SKILLED TEAM <br />
                                            MEMBERS </h2>
                                        <span className="counterup__banner--items__number js-counter text-white" data-count="100">0</span>
                                    </div>
                                    <div className="counterup__banner--items text-center">
                                        <h2 className="counterup__banner--items__text text-white">HAPPY <br />
                                            CUSTOMERS</h2>
                                        <span className="counterup__banner--items__number js-counter text-white" data-count="80">0</span>
                                    </div>
                                    <div className="counterup__banner--items text-center">
                                        <h2 className="counterup__banner--items__text text-white">MONTHLY <br />
                                            ORDERS</h2>
                                        <span className="counterup__banner--items__number js-counter text-white" data-count="70">0</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- End counterup banner section -->

    <!-- Start team members section --> */}
                <section className="team__section section--padding">
                    <div className="container">
                        <div className="section__heading text-center mb-50">
                            <h2 className="section__heading--maintitle">Why Choose Us</h2>
                        </div>
                        <div className="team__container">
                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-sm-6 col-6 custom-col">
                                    <div className="team__items text-center">
                                        <div className="team__thumb">
                                            <img className="team__thumb--img border-radius-50" src="assets/img/ik1.png" alt="" />
                                        </div>
                                        <div className="team__content ">
                                            <h3 className="team__content--title">High quality and low cost</h3>
                                            <span className="team__content--subtitle" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Empowering customers and sellers to connect instantly, discover trending products, and enjoy seamless, secure shopping with fast nationwide delivery.

                                            </span>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4 col-sm-6 col-6 custom-col">
                                    <div className="team__items text-center">
                                        <div className="team__thumb">
                                            <img className="team__thumb--img border-radius-50" src="assets/img/ik2.png" alt="" />
                                        </div>
                                        <div className="team__content ">
                                            <h3 className="team__content--title">50K Happy Customers</h3>
                                            <span className="team__content--subtitle" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Bringing you quality products, unbeatable deals, and a smooth shopping experience designed for comfort, convenience, and complete satisfaction.

                                            </span>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-6 custom-col">
                                    <div className="team__items text-center">
                                        <div className="team__thumb">
                                            <img className="team__thumb--img border-radius-50" src="assets/img/ik3.png" alt="" />
                                        </div>
                                        <div className="team__content ">
                                            <h3 className="team__content--title">A transparent Refund policy</h3>
                                            <span className="team__content--subtitle">Explore thousands of top brands, compare prices, and shop confidently with secure payments, easy returns, and trusted delivery partners.

                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- End team members section -->

    <!-- Start testimonial section --> */}
                <section
                    className="testimonial__section section--padding pt-0"
                    style={{
                        position: "relative",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        padding: "100px 0",
                    }}
                >
                    {/* ✅ Background image (diagonal right-side) */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url('/assets/img/ovaraybg12345.png')`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            zIndex: 0,
                            pointerEvents: "none",
                        }}
                    ></div>

                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 1,
                            pointerEvents: "none",
                        }}
                    >

                    </div>

                    {/* ✅ Content */}
                    <div className="container" style={{ position: "relative", zIndex: 3, padding: '25px', marginTop: '50px', background: 'white', borderRadius: '6px', boxShadow: "1px 2px 4px rgba(0,0,0,0.1), 0 -2px 4px rgba(0,0,0,0.1), 2px 0 4px rgba(0,0,0,0.1), -2px 0 4px rgba(0,0,0,0.1)", border: '2px solid #CEB256' }}>
                        <div style={{ textAlign: "center", marginBottom: "50px", position: "relative", marginTop: '10px' }}>
                            <h2
                                style={{
                                    fontSize: "28px",
                                    fontWeight: "700",
                                    color: "#000",
                                    textTransform: "uppercase",
                                    display: "inline-block",
                                    position: "relative",
                                    padding: "0 20px",
                                }}
                            >
                                {/* Top line */}
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "-10px", // above the text
                                        left: "50%", // center horizontally
                                        transform: "translateX(-50%)",
                                        width: "20%", // length of the line
                                        height: "3px",
                                        backgroundColor: "#CEB256",
                                        display: "block",
                                    }}
                                ></span>

                                What Clients Say

                                {/* Bottom line */}
                                <span
                                    style={{
                                        position: "absolute",
                                        bottom: "-10px", // below the text
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: "20%",
                                        height: "3px",
                                        backgroundColor: "#CEB256",
                                        display: "block",
                                    }}
                                ></span>
                            </h2>

                            {/* <p
                            style={{
                            maxWidth: "650px",
                            margin: "0 auto",
                            color: "#555",
                            fontSize: "16px",
                            }}
                        >
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </p> */}
                        </div>
                        <Swiper
                            modules={[Autoplay, Pagination, Navigation]}
                            spaceBetween={30}
                            slidesPerView={1}
                            loop={true}
                            autoplay={{ delay: 3500, disableOnInteraction: false }}
                            pagination={{ clickable: true }}
                            navigation={true}
                            breakpoints={{
                                768: { slidesPerView: 2 },
                                1024: { slidesPerView: 3 },
                            }}
                            className="product__swiper seller-slider"
                        >
                            {testimonials.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div
                                        className="testimonial__card"
                                        style={{
                                            background: "#fff",
                                            borderRadius: "10px",
                                            padding: "35px 25px",
                                            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                                            textAlign: "center",
                                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-6px)";
                                            e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.15)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.08)";
                                        }}
                                    >
                                        <img
                                            src={item.img}
                                            alt={item.name}
                                            style={{
                                                width: "80px",
                                                height: "80px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                marginBottom: "15px",
                                            }}
                                        />
                                        <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#222", marginBottom: "5px" }}>
                                            {item.name}
                                        </h3>
                                        <p style={{ color: "#999", fontSize: "14px" }}>{item.subtitle}</p>
                                        <p style={{ color: "#444", fontSize: "15px", marginTop: "10px", lineHeight: "1.6" }}>
                                            {item.desc}
                                        </p>
                                        <ul className="rating testimonial__rating d-flex justify-content-center" style={{ marginTop: "10px", listStyle: "none", padding: 0 }}>
                                            {[...Array(5)].map((_, star) => (
                                                <li key={star} style={{ color: "#E7B768", margin: "0 2px" }}>★</li>
                                            ))}
                                        </ul>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>


                    </div>
                </section>
                {/* <!-- End testimonial section --> */}

            </main>

            <Footer />
            {/* <!-- End footer section --> */}
            {/* 
 <!-- Scroll top bar --> */}
            <button id="scroll__top"><svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M112 244l144-144 144 144M256 120v292" /></svg></button>
        </>
    )
}

export default About